import { Injectable } from '@angular/core';

import { UserManager, UserManagerSettings, User } from 'oidc-client';

import { SessionService } from '@src/services';

import {JwtHelperService} from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  private manager:any;
  private user: User = null;
  public authority:string;
  public client_id:string;
  public scope:string;
  public url:string = location.origin

  constructor(private sessionService:SessionService, private jwtHelper: JwtHelperService) {
      const auth = localStorage.hasOwnProperty('authority')
      const client_id = localStorage.hasOwnProperty('client_id')
      const scope = localStorage.hasOwnProperty('scope')
      let AuthType = JSON.parse(localStorage.getItem('AuthType'))
     if(AuthType == 'oidc' && auth && client_id && scope){
      this.manager = new UserManager(getClientSettings(this.url));
      this.manager.getUser().then(user => {
        this.user = user;
        if(this.user?.expired){
          this.RefreshToken()
        }
        else {
          this.sessionService.user = this.user;
        }
      });
    }
  }

  setManagerSetting(){
    const auth = localStorage.hasOwnProperty('authority')
    const client_id = localStorage.hasOwnProperty('client_id')
    const scope = localStorage.hasOwnProperty('scope')
    if(auth && client_id &&  scope){
      this.manager = new UserManager(getClientSettings(this.url));
      this.manager.getUser().then(user => {
        this.user = user;
        this.sessionService.user = this.user;
      });
   }
  }

  isLoggedIn(): boolean {
    return this.user != null && !this.user.expired;
  }


  async RefreshToken(): Promise<boolean> {
    if (this.user != null && this.user.expired) {
      this.user = await this.manager.signinSilent()
      this.sessionService.user = this.user;
      return true;
    }
  }

  setConfiguration(configuration:any):void {
    localStorage.setItem('authority', JSON.stringify(configuration.Properties.authority));
    localStorage.setItem('client_id', JSON.stringify(configuration.Properties.client_id));
    localStorage.setItem('scope', JSON.stringify(configuration.Properties.scope));
    localStorage.setItem('AuthOnly', JSON.stringify(configuration.AuthOnly))
  } 

  getUser(): User {
    return this.user;
  }

  public async testConnection(proprties:any):Promise<boolean> {
    this.manager = new UserManager(this.getClientTestSettings(this.url,proprties));
    const user = await this.manager.getUser()
    //console.log(user)
    if(user){
      return true;
    }
    return false;
  }

  isExpired(): boolean {
    try{
      if (this.jwtHelper.isTokenExpired(this.sessionService.user.access_token)) {
        return false
       } else {
         return true
       }
    }
    catch(e){
      console.log(e)
    }
  }

  getClaims(): any {
    return this.user.profile;
  }

  getAuthorizationHeaderValue(): string {
    return `${this.user.token_type} ${this.user.access_token}`;
  }

  startAuthentication(): Promise<void> {
    return this.manager.signinRedirect();
  }




  signOutAuthentication(){
    this.manager
      .signoutRedirect()
      .then(res => {
          console.log('Redirection to signout triggered.', res);
      })
  }

  getClientTestSettings(url:string,proprties:any): UserManagerSettings {
    return {
      authority: proprties.AuthorityURI,
      client_id: proprties.WebClientId,
      redirect_uri: url + '/usersRolesManagement/advancedManagement/oidcConfiguration',
      post_logout_redirect_uri: url + '/login',
      response_type: "code",
      scope: localStorage.getItem('scope'),
      automaticSilentRenew: false,
      filterProtocolClaims: true,
      loadUserInfo: true,
      accessTokenExpiringNotificationTime: 500
    };
  }

  completeAuthentication(): Promise<void> {
    return this.manager.signinRedirectCallback().then(user => {
      this.user = user;
      this.sessionService.user = user;
    }).catch(err=>{
        console.log("== respose signinRedirectCallback error==>",err)
    });
  }
}

export function getClientSettings(url:string): UserManagerSettings {
  return {
    authority: JSON.parse(localStorage.getItem('authority')),
    client_id: JSON.parse(localStorage.getItem('client_id')),
    redirect_uri: url + '/auth-callback',
    post_logout_redirect_uri: url + '/login',
    response_type: "code",
    scope: JSON.parse(localStorage.getItem('scope')),
    automaticSilentRenew: false,
    filterProtocolClaims: true,
    loadUserInfo: true,
    accessTokenExpiringNotificationTime: 500
  };
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/services/auth.service.ts